import { render } from "./SVGArrowUp.vue?vue&type=template&id=4de259e0"
import script from "./SVGArrowUp.vue?vue&type=script&lang=js"
export * from "./SVGArrowUp.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__